import React from "react";

export const Download = ({fill}) => {
  return (
    <svg
      width="10.49"
      height="11.5"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.4465 9.08686C1.7268 9.08686 1.95404 9.31409 1.95404 9.59439V10.9478C1.95404 11.0413 2.02978 11.117 2.12321 11.117H10.2438C10.3372 11.117 10.413 11.0413 10.413 10.9478V9.59439C10.413 9.31409 10.6402 9.08686 10.9205 9.08686C11.2008 9.08686 11.428 9.31409 11.428 9.59439V10.9478C11.428 11.6019 10.8978 12.1321 10.2438 12.1321H2.12321C1.46917 12.1321 0.938965 11.6019 0.938965 10.9478V9.59439C0.938965 9.31409 1.1662 9.08686 1.4465 9.08686Z"
        fill="#474747"
      />
      <path
        d="M5.32945 0.62793C4.98136 0.62793 4.69098 0.893961 4.66059 1.24073C4.55662 2.42681 4.53828 3.61873 4.60566 4.80721C4.43852 4.81645 4.27145 4.82715 4.10445 4.83932L3.09648 4.9128C2.70784 4.94113 2.49059 5.37447 2.70041 5.70283C3.4191 6.82759 4.34516 7.80539 5.42922 8.58412L5.83304 8.87421C6.04249 9.02466 6.32458 9.02466 6.53403 8.87421L6.93785 8.58412C8.02191 7.80539 8.94797 6.82759 9.66667 5.70283C9.87648 5.37447 9.65923 4.94113 9.27059 4.9128L8.26262 4.83932C8.09562 4.82715 7.92855 4.81645 7.76141 4.80721C7.82879 3.61873 7.81045 2.42681 7.70648 1.24072C7.67608 0.89396 7.38572 0.62793 7.03762 0.62793H5.32945Z"
        fill={fill ? fill : "#474747"}
      />
    </svg>
  );
};
